/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AllScheduleDto } from '../../models/all-schedule-dto';
import { Object } from '../../models/object';

export interface AllScheduleControllerFindAllForParent$Params {

/**
 * 유저 ID
 */
  userId?: string;

/**
 * 아동 ID
 */
  children?: Array<string>;

/**
 * 센터 ID
 */
  centerIds?: Array<string>;

/**
 * 선생님 ID
 */
  teacherIds?: Array<string>;

/**
 * 치료 상태
 */
  ticketStatusList?: Array<'BEFORE_COUNSELING' | 'PENDING' | 'PROGRESS' | 'COMPLETED'>;

/**
 * 치료 유형
 */
  ticketTypes?: Array<string>;

/**
 * 바우처
 */
  vouchers?: Array<string>;

/**
 * 유형
 */
  types?: Array<'PERSONAL' | 'CENTER' | 'COUNSELING' | 'TREATMENT' | 'SUPPLEMENT'>;

/**
 * 날짜 유형
 */
  dateType?: Object;

/**
 * 시작 날짜
 */
  date?: string;

/**
 * 시작 날짜
 */
  startAt?: string;

/**
 * 종료 날짜
 */
  endAt?: string;

/**
 * 검색어
 */
  query?: string;
}

export function allScheduleControllerFindAllForParent(http: HttpClient, rootUrl: string, params?: AllScheduleControllerFindAllForParent$Params, context?: HttpContext): Observable<StrictHttpResponse<AllScheduleDto>> {
  const rb = new RequestBuilder(rootUrl, allScheduleControllerFindAllForParent.PATH, 'get');
  if (params) {
    rb.query('userId', params.userId, {});
    rb.query('children', params.children, {});
    rb.query('centerIds', params.centerIds, {});
    rb.query('teacherIds', params.teacherIds, {});
    rb.query('ticketStatusList', params.ticketStatusList, {});
    rb.query('ticketTypes', params.ticketTypes, {});
    rb.query('vouchers', params.vouchers, {});
    rb.query('types', params.types, {});
    rb.query('dateType', params.dateType, {});
    rb.query('date', params.date, {});
    rb.query('startAt', params.startAt, {});
    rb.query('endAt', params.endAt, {});
    rb.query('query', params.query, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AllScheduleDto>;
    })
  );
}

allScheduleControllerFindAllForParent.PATH = '/api/all-schedule/parent';
